import { UNREAD_EMPHASIS_FONT_WEIGHT } from '~components/Messaging/UnreadCountBadge';

export const unreadTabAccentSx = (accentColor: string) => ({
  color: accentColor,
  fontWeight: UNREAD_EMPHASIS_FONT_WEIGHT,
});
